import { render, staticRenderFns } from "./FieldMetrics.vue?vue&type=template&id=dcf5637a&"
import script from "./FieldMetrics.vue?vue&type=script&lang=ts&"
export * from "./FieldMetrics.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports